import { render, staticRenderFns } from "./RecipientTable.vue?vue&type=template&id=644e9df1"
import script from "./RecipientTable.vue?vue&type=script&lang=js"
export * from "./RecipientTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports